import { Layout, Eyebrow, ChromeHeading } from "../components/funnel";
import { MailLink } from "../components/legal/MailLink";
import { ContactForm } from "../components/legal/ContactForm";

export default function ContactPage() {
  return (
    <Layout>
      <section className="relative overflow-clip" data-testid="contact-page">
        <div className="breathe-glow pointer-events-none absolute -right-40 top-0 h-[560px] w-[min(900px,140vw)]" aria-hidden="true" />
        <div className="gutter relative grid gap-12 py-16 sm:py-24 lg:grid-cols-[5fr_6fr] lg:gap-16">
          <div className="fade-up lg:pt-4">
            <Eyebrow data-testid="contact-eyebrow">CONTACT</Eyebrow>
            <ChromeHeading as="h1" className="mt-4 text-[44px] sm:text-6xl lg:text-7xl" data-testid="contact-title">Get in touch</ChromeHeading>
            <p className="mt-6 max-w-md text-[16px] leading-relaxed text-[#cfc7b6] sm:text-lg" data-testid="contact-sub">Questions about the class, the toolkit or the mentorship? Send us a message and our team will get back to you.</p>
            <p className="mt-8 text-[15px] text-[#e4dccb]" data-testid="contact-email-row">Email us directly: <MailLink data-testid="contact-email-link" /></p>
          </div>
          <ContactForm />
        </div>
      </section>
    </Layout>
  );
}
